import { render, staticRenderFns } from "./AddattachmentBorderIcon.vue?vue&type=template&id=0f2f5292"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports